"use client";

import { useTranslations } from "next-intl";

export type BillingInterval = "monthly" | "yearly";

interface BillingIntervalToggleProps {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
}

export function BillingIntervalToggle({
  value,
  onChange,
}: BillingIntervalToggleProps) {
  const t = useTranslations("Plans");

  return (
    <div className="inline-flex flex-col sm:flex-row sm:items-center gap-3">
      <div
        role="group"
        aria-label={t("billingIntervalAria")}
        className="inline-flex p-1 rounded-lg bg-slate-800/60 border border-slate-700"
      >
        <button
          type="button"
          onClick={() => onChange("monthly")}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            value === "monthly"
              ? "bg-teal-primary/25 text-teal-light border border-teal-primary/50"
              : "text-slate-400 hover:text-slate-200 border border-transparent"
          }`}
        >
          {t("monthly")}
        </button>
        <button
          type="button"
          onClick={() => onChange("yearly")}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            value === "yearly"
              ? "bg-teal-primary/25 text-teal-light border border-teal-primary/50"
              : "text-slate-400 hover:text-slate-200 border border-transparent"
          }`}
        >
          {t("yearly")}
        </button>
      </div>
      {value === "yearly" ? (
        <span className="text-xs font-semibold text-teal-light bg-teal-primary/15 border border-teal-primary/30 px-2.5 py-1 rounded-full">
          {t("annualDiscountBadge")}
        </span>
      ) : null}
    </div>
  );
}
